__turbopack_context__.v({
  "ant-modal-body": "_4a_Ffa_ant-modal-body",
  "ant-modal-content": "_4a_Ffa_ant-modal-content",
  "bgModal": "_4a_Ffa_bgModal",
  "btn": "_4a_Ffa_btn",
  "btnFooter": "_4a_Ffa_btnFooter",
  "btnPosition": "_4a_Ffa_btnPosition",
  "card": "_4a_Ffa_card",
  "cards": "_4a_Ffa_cards",
  "content": "_4a_Ffa_content",
  "divbtn": "_4a_Ffa_divbtn",
  "gridContainer": "_4a_Ffa_gridContainer",
  "gridItem": "_4a_Ffa_gridItem",
  "headContact": "_4a_Ffa_headContact",
  "p": "_4a_Ffa_p",
  "p1": "_4a_Ffa_p1",
  "page-body-wrap": "_4a_Ffa_page-body-wrap",
  "paragraph": "_4a_Ffa_paragraph",
  "paragraph-content": "_4a_Ffa_paragraph-content",
  "slider": "_4a_Ffa_slider",
  "sosmed": "_4a_Ffa_sosmed",
  "store": "_4a_Ffa_store",
  "t": "_4a_Ffa_t",
  "title": "_4a_Ffa_title",
  "wrap-container": "_4a_Ffa_wrap-container",
  "wrap-content": "_4a_Ffa_wrap-content",
});
